import React from 'react'

const WhyChooseUs = () => {
  return (
    
    
    <section className="py-5 md:py-10 lg:py-14">
        <div className="container mx-auto" data-aos="fade-up" data-aos-duration="3000">
            <div className="max-w-xl mx-auto text-center mb-12">
                {/* <span className="py-1 px-3 rounded-md text-xs font-medium uppercase tracking-wider border border-default-200 text-default-950">Our Services</span> */}
                <h2 className="md:text-4xl text-2xl font-semibold text-[#182e55] mt-3">Why Choose Us?</h2>
                <p className="text-sm mt-3 px-2 md:px-0">Our product line includes a variety of ladders designed for different applications, including step ladders, extension ladders, and customized solutions.</p>
            </div>

            <div className="grid 2xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 px-2">
               
                    <div className="border border-gray-200 shadow p-6 flex flex-wrap md:flex-nowrap gap-5 rounded-lg bg-white ">
                        <div>
                            <div className="flex items-center justify-center rounded-md w-10 h-10 text-xl text-gray-50 bg-blue-950">1</div>
                        </div>
                        <div>
                            <h3 className="md:text-xl text-lg font-medium text-blue-950 mb-4">Durable and Lightweight</h3>
                            <p className="md:text-base font-medium mb-4">Our ladders are crafted from the finest aluminum, ensuring long-lasting durability without the added weight. </p>
                            
                        </div>
                    </div>
                

                
                    <div className="border border-gray-200 shadow p-6 flex flex-wrap md:flex-nowrap gap-5 rounded-lg bg-white ">
                        <div>
                            <div className="flex items-center justify-center rounded-md w-10 h-10 text-xl text-gray-50 bg-blue-950">2</div>
                        </div>
                        <div>
                            <h3 className="md:text-xl text-lg font-medium text-blue-950 mb-4">Customized Solutions</h3>
                            <p className="md:text-base font-medium mb-4">We offer custom ladder designs to suit your specific industry or project needs.</p>
                            
                        </div>
                    </div>
                

                
                    <div className="border border-gray-200 shadow p-6 flex flex-wrap md:flex-nowrap gap-5 rounded-lg bg-white ">
                        <div>
                            <div className="flex items-center justify-center rounded-md w-10 h-10 text-xl text-gray-50 bg-blue-950">3</div>
                        </div>
                        <div>
                            <h3 className="md:text-xl text-lg font-medium text-blue-950 mb-4">Competitive Pricing</h3>
                            <p className="md:text-base font-medium mb-4">Quality doesn't have to come at a premium. We offer competitive prices without compromising on safety or performance.</p>
                            
                        </div>
                    </div>
                

                    <div className="border border-gray-200 shadow p-6 flex flex-wrap md:flex-nowrap gap-5 rounded-lg bg-white ">
                        <div>
                            <div className="flex items-center justify-center rounded-md w-10 h-10 text-xl text-gray-50 bg-blue-950">4</div>
                        </div>
                        <div>
                            <h3 className="md:text-xl text-lg font-medium text-blue-950 mb-4">Exceptional Customer Service</h3>
                            <p className="md:text-base font-medium mb-4">Our team is dedicated to providing top-tier customer support, from helping you choose the right ladder to ensuring timely delivery.</p>
                            
                        </div>
                    </div>
            </div>
        </div>
    </section>
    
    
  )
}

export default WhyChooseUs